import styled from '@emotion/styled';
import { Divider, Switch, notification } from 'antd';
import { useEffect, useState } from 'react';
import { MoonLoader } from 'react-spinners';
import { ProfilEntity } from '../../../../entities/profil.entity';
import { UserEntity } from '../../../../entities/utilisateur.entity';
import {
  createUtilisateurProfil,
  deleteUtilisateurProfil,
  getProfils,
} from '../network';

const Container = styled.div`
  color: var(--mt-text);

  .profile-intro {
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 14px;
    padding: 14px;
    background: var(--mt-surface);
  }

  .profile-intro span {
    color: var(--mt-warning);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .profile-intro h3 {
    margin: 5px 0 0;
    color: var(--mt-text);
    font-family: Poppins-B;
  }

  .profile-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border: 1px solid var(--mt-border);
    border-radius: 8px;
    margin-bottom: 8px;
    padding: 10px 12px;
    background: var(--mt-card);
  }

  .pro_name {
    color: var(--mt-text);
    font-family: Poppins-B;
  }
`;

export const ProfilForm = ({
  user,
  userProfils,
}: {
  user?: UserEntity;
  userProfils: ProfilEntity[];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [profils, setProfils] = useState<ProfilEntity[]>([]);
  const [switchVal, setSwitchVal] = useState({});

  useEffect(() => {
    getProfils().then(({ data }) => {
      setProfils(data);
    });
  }, []);

  useEffect(() => {
    if (profils.length > 0) {
      let vals = {};
      for (let pro of profils) {
        vals[pro.id] = userProfils.find((upro) => upro.id === pro.id)
          ? true
          : false;
      }
      setSwitchVal(vals);
    }
    // eslint-disable-next-line
  }, [user, profils]);

  const createProfil = async (user: string, profil: string) => {
    setIsLoading(true);
    await createUtilisateurProfil({ utilisateur: user, profil: profil }).then(
      ({ statusCode, data }) => {
        setIsLoading(false);
        if (statusCode?.toString()[0] === '2') {
          notification.success({
            message: 'Succès',
            description: 'Le profil a été attribué avec succès',
          });
        } else {
          notification.info({
            message: 'Erreur',
            description: data.message,
          });
        }
      },
    );
    setIsLoading(false);
  };

  const deleteProfil = async (user: string, profil: string) => {
    setIsLoading(true);
    await deleteUtilisateurProfil({ userId: user, profilId: profil }).then(
      ({ statusCode, data }) => {
        setIsLoading(false);
        if (statusCode?.toString()[0] === '2') {
          notification.success({
            message: 'Succès',
            description: 'Le profil a été désactivé avec succès',
          });
        } else {
          notification.info({
            message: 'Erreur',
            description: data.message,
          });
        }
      },
    );
    setIsLoading(false);
  };

  return (
    <Container>
      <div className='profile-intro'>
        <span>Profils utilisateur</span>
        <h3>{user?.nom} {user?.prenom}</h3>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <MoonLoader size={20} color='green' loading={isLoading} />
      </div>
      <Divider />

      {profils.map((pro) => (
        <div key={pro.id} className='profile-row'>
          <div className='pro_name'>{pro.nom}</div>
          <Switch
            checked={switchVal[pro.id]}
            onChange={(e) => {
              setSwitchVal({ ...switchVal, [pro.id]: e.valueOf() });
              if (user && e.valueOf() === true) {
                createProfil(user.url, pro.url);
              } else if (user && e.valueOf() === false) {
                deleteProfil(user.id, pro.id);
              }
            }}
          />
        </div>
      ))}
    </Container>
  );
};
